<template>
  <Modal title="代开配置" v-model="visible" width="920" class="my-modal" :mask-closable="false" :footer-hide="true">
    <div class="product-name">分配产品:{{ productName }}</div>
    <Transfer
      :titles="['不可汇总代开', '可汇总代开']"
      :data="listData"
      :target-keys="targetKeys"
      :render-format="renderFormat"
      :filter-method="filterMethod"
      filterable
      style="width: 100%"
      @on-change="handleChange"
    ></Transfer>

    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save">保存</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      productName: '',
      listData: [],
      targetKeys: []
    };
  },
  methods: {
    async getListData() {
      this.loading = true;
      try {
        const res = await this.$http({
          url: '/buz/userCashWithdrawLog/queryInvoiceConfig',
          type: 'GET',
          data: {}
        });
        this.listData = res.data.notInvoiceList.map(item => {
          item.key = item.id;
          return item;
        });
        this.targetKeys = res.data.canInvoiceList.map(item => item.id);
      } catch (e) {
        console.log(e);
        this.loading = false;
      }

      this.loading = false;
    },
    async open() {
      this.listData = [];
      this.targetKeys = [];
      await this.getListData();
      this.visible = true;
    },
    save() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http({
        url: '/buz/userCashWithdrawLog/saveInvoiceConfig',
        type: 'POST',
        data: {
          canInvoiceList: this.targetKeys.map(i => {
            return this.listData.find(item => item.id == i);
          }),
          notInvoiceList: this.listData || []
        }
      })
        .then(res => {
          this.visible = false;
          this.$notice.success('操作成功');
          this.$emit('success');
        })
        .finally(() => {
          window.setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
    renderFormat(item) {
      return item.name;
    },
    handleChange(newTargetKeys) {
      this.targetKeys = newTargetKeys;
    },
    filterMethod(data, query) {
      return data.name.indexOf(query) > -1;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-body {
  padding: 10px 20px 80px !important;
}
.ivu-transfer {
  text-align: center;
  /deep/ .ivu-transfer-list {
    text-align: left;
    width: 400px;
    height: 400px;
  }
}

.product-name {
  padding-bottom: 10px;
  font-weight: bold;
}
</style>
